import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/hebing', component: () => import('@/views/hebing/hebing'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home', hideNavbar: true}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/customer',
    component: Layout,
    name: 'customer',
    meta: {title: '客户列表', icon: 'customer'},
    children: [
      {
        path: 'customer',
        name: 'customer',
        component: () => import('@/views/customer/index'),
        meta: {title: '客户列表', icon: 'ums-admin'}
      },
    ]
  },

  {
    path: '/goods',
    component: Layout,
    name: 'goods',
    meta: {title: '商品', icon: 'product'},
    children: [
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/goods/product/index'),
        meta: {title: '商品列表', icon: 'product-list'}
      },
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      {
        path: 'miniImage',
        name: 'miniImage',
        component: () => import('@/views/ums/miniImage/index'),
        meta: {title: '图片管理', icon: 'miniImage'}
      },
      {
        path: 'approvalCategory',
        name: 'approvalCategory',
        component: () => import('@/views/ums/approvalCategory/index'),
        meta: {title: '审批设置', icon: 'approvalCategory'}
      },
    ]
  },
  {
    path: '/massagist',
    component: Layout,
    redirect: '/massagist/management',
    name: 'massagist',
    meta: {title: '技师管理', icon: 'ums-role'},
    children: [
      {
        path: 'management',
        name: 'management',
        component: () => import('@/views/massagist/management/index'),
        meta: {title: '技师列表', icon: 'massagist'}
      },
      {
        path: 'schedules',
        name: 'schedules',
        component: () => import('@/views/massagist/schedules/index'),
        meta: {title: '技师排班', icon: 'schedules'}
      },
      {
        path: 'leave',
        name: 'leave',
        component: () => import('@/views/massagist/leave/index'),
        meta: {title: '技师请假', icon: 'leave'}
      },
      {
        path: 'comment',
        name: 'comment',
        component: () => import('@/views/massagist/comment/index'),
        meta: {title: '技师评价', icon: 'comment'}
      },
    ]
  },
  {
    path: '/shop',
    component: Layout,
    redirect: '/shop/shopList',
    name: 'shop',
    meta: {title: '门店管理', icon: 'shop'},
    children: [
      {
        path: 'shopList',
        name: 'shopList',
        component: () => import('@/views/shop/shopList/index'),
        meta: {title: '门店列表', icon: 'shopList'}
      },
      {
        path: 'room',
        name: 'room',
        component: () => import('@/views/shop/room/index'),
        meta: {title: '房间列表', icon: 'room'}
      },
      {
        path: 'bed',
        name: 'bed',
        component: () => import('@/views/shop/bed/index'),
        meta: {title: '床位列表', icon: 'bed'}
      },
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    redirect: '/statistics/revenue',
    name: 'statistics',
    meta: {title: '数据统计', icon: 'shop'},
    children: [
      {
        path: 'revenue',
        name: 'revenue',
        component: () => import('@/views/statistics/revenue/index'),
        meta: {title: '经营流水', icon: 'room'}
      },
      {
        path: 'serviceDuration',
        name: 'serviceDuration',
        component: () => import('@/views/statistics/serviceDuration/index'),
        meta: {title: '服务时长', icon: 'bed'}
      },
      {
        path: 'salarySet',
        name: 'salarySet',
        component: () => import('@/views/statistics/salaryDetail/salarySetList'),
        meta: {title: '薪资设置', icon: 'salary'}
      },
      {
        path: 'salaryDetail',
        name: 'salaryDetail',
        component: () => import('@/views/statistics/salaryDetail/index'),
        meta: {title: '薪资明细', icon: 'salary'}
      },
      {
        path: 'monthly',
        name: 'monthly',
        component: () => import('@/views/statistics/monthly/index'),
        meta: {title: '月度统计', icon: 'monthly'}
      },
    ]
  },
  {
    path: '/promotion',
    component: Layout,
    redirect: '/promotion/giftCard',
    name: 'promotion',
    meta: {title: '活动推广', icon: 'shop'},
    children: [
      {
        path: 'giftCard',
        name: 'giftCard',
        component: () => import('@/views/promotion/giftCard/index'),
        meta: {title: '礼品卡', icon: 'room'}
      },
      {
        path: 'activity',
        name: 'activity',
        component: () => import('@/views/promotion/activity/index'),
        meta: {title: '活动列表', icon: 'sms-hot'}
      },
      {
        path: 'discount',
        name: 'discount',
        component: () => import('@/views/promotion/discount/index'),
        meta: {title: '折扣配置', icon: 'sms-hot'}
      },
    ]
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/order/order',
    name: 'order',
    meta: {title: '订单列表', icon: 'order'},
    children: [
      {
        path: 'ordinary',
        name: 'ordinary',
        component: () => import('@/views/order/ordinary/index'),
        meta: {title: '普通订单', icon: 'order'}
      },
      {
        path: 'coupons',
        name: 'coupons',
        component: () => import('@/views/order/coupons/index'),
        meta: {title: '卡券订单', icon: 'coupons'}
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/order/coupon/index'),
        meta: {title: '券包列表', icon: 'sms-coupon'}
      },
      {
        path: 'approval',
        name: 'approval',
        component: () => import('@/views/order/approval/index'),
        meta: {title: '退款审批'},
        hidden: true
      },
    ]
  },,
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js